"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
var getToolbarPosition = function (toolbarPosition, isMobileView) {
    if (isMobileView) {
        return 'bottom';
    }
    return toolbarPosition;
};
exports.props = withCompInfo_1.withCompInfo(['compData', 'compProps', 'isMobileView'], function (_a) {
    var compData = _a.compData, compProps = _a.compProps, isMobileView = _a.isMobileView;
    var toolbarPosition = getToolbarPosition(compProps.toolbarPosition, isMobileView);
    var result = {
        allowLinks: compProps.allowLinks,
        placeholder: compProps.placeholder,
        value: compData.value,
        textAlignment: compProps.textAlignment,
        toolbarPosition: toolbarPosition,
        readOnly: compProps.readOnly || false,
        isDisabled: compProps.isDisabled || false,
        maxLength: compData.maxLength || undefined,
    };
    return result;
});
exports.css = withCompInfo_1.withCompInfo(['compProps', 'styleProperties'], function (_a, carmiData) {
    var compProps = _a.compProps, styleProperties = _a.styleProperties;
    var textPadding = compProps.textPadding && compProps.textPadding > 0
        ? compProps.textPadding
        : 0;
    var borderRadius = styleProperties.rd.split(' ');
    // santa-editor default value doesn't include px, so we have to add it :(
    // https://github.com/wix-private/santa-editor/blob/master/editor-add-panel/addPanelSectionsEN/sections/developer/richTextBoxSection.js#L89
    var borderWidth = styleProperties.brw.includes('px')
        ? styleProperties.brw
        : styleProperties.brw + "px";
    return {
        '--fontSize': carmiData.font.size + "px",
        '--textPadding': textPadding + "px",
        '--textPaddingTop': textPadding / 2 + "px",
        '--toolbar-top-radius': borderRadius[0] + " " + borderRadius[1] + " 0 0",
        '--toolbar-bottom-radius': "0 0 " + borderRadius[2] + " " + borderRadius[3],
        '--brw': borderWidth,
    };
});
//# sourceMappingURL=RichTextBox.js.map